import type { ChangeEventHandler, FieldsetHTMLAttributes } from 'react'

import clsx from 'clsx'
import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { typo } from 'shared/styles'

import {
	campaignsActions,
	campaignsSelectors
} from '../../../redux/reducers/campaigns'
import { CustomTip } from '../../atoms/tooltipCustom'
import css from './Statuses.module.scss'

const labels = ['draft', 'paused', 'active', 'completed']
const filters = ['drafted', 'stopped', 'active', 'completed'] as const

export function Statuses({
	className,
	...props
}: FieldsetHTMLAttributes<HTMLFieldSetElement>) {
	const state = useAppSelector(campaignsSelectors.filters)

	const dispatch = useAppDispatch()

	const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
		event => {
			const filter = event.target.value as (typeof filters)[number]

			dispatch(campaignsActions.toggleFilter(filter))
		},
		[dispatch]
	)

	return (
		<fieldset className={clsx(className, css.root)} {...props}>
			<legend className={clsx(typo.buttonSm, css.title)}>Status: </legend>
			<div className={css.filters}>
				{filters.map((filter, index) => (
					<CustomTip
						arrow
						enterDelay={500}
						enterNextDelay={500}
						key={filter}
						leaveDelay={0}
						title={labels[index]}
					>
						<input
							checked={state[filter]}
							className={clsx(css.filter, css[filter])}
							id={filter}
							name='filter'
							onChange={onChange}
							type='checkbox'
							value={filter}
						/>
					</CustomTip>
				))}
			</div>
		</fieldset>
	)
}
